import { render } from "./SingleChoiceQuestion.vue?vue&type=template&id=52a325ae&scoped=true"
import script from "./SingleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./SingleChoiceQuestion.vue?vue&type=script&lang=js"

import "./SingleChoiceQuestion.vue?vue&type=style&index=0&id=52a325ae&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a325ae"]])

export default __exports__